
import { useSelector } from 'react-redux';

import { RootState } from '@share/utils';
import { BookingErrorsEnum } from '@share/common-types';
import { ModalAvailabilityStatus, Type } from '@components';

import './style.scss';

interface IProps {
  isGetaways?: boolean;
  certificateApplied?: boolean;
}

export function CondoAvailabilityStatusModal(props: IProps) {

  const condoReviewBookStore = useSelector((state: RootState) => state.condoReviewBookStore);
  const condoDetailsStore = useSelector((state: RootState) => state.condoDetailsStore);
  
  const { isGetaways, certificateApplied } = props;
  const { error, condo } = condoDetailsStore;
  const { bookingErrorCode, condoBookingSummary } = condoReviewBookStore;
  
  const hasSoldout = BookingErrorsEnum.SoldOut === error || BookingErrorsEnum.SoldOut === bookingErrorCode;
  const isUnavailable = BookingErrorsEnum.RoomsUnavailable === error || BookingErrorsEnum.RoomsUnavailable === bookingErrorCode;;
  const dealStatus = condo?.dealStatus;

  return (
    <ModalAvailabilityStatus
      hasSoldout={hasSoldout}
      isUnavailable={isUnavailable}
      dealStatus={dealStatus}
      type={isGetaways ? Type.GETAWAYS : Type.CONDOS}
      propertyId={condoBookingSummary?.bookingCard?.condoId || ''}
      bookingErrorCode={bookingErrorCode || ''}
      certificateApplied={certificateApplied}
    />
  );
}
